import React, { useRef, useState } from "react";
import { ReactComponent as Refresh } from "../assets/images/refresh.svg";
import seeMoreIcon from "../assets/images/see-more.svg";
import QRCode from "qrcode.react";
import moment from "jalali-moment";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { IPassportInfo } from "../models/passport.model";
import { capitalizeFirstLetter, getToken } from "../helper/helper";
import i18n from "../i18n";
import SwitchTabs from "./SwitchTabs";

interface IProps {}

interface OwnerSectionBottomProps {
  issueDate?: any;
}

interface OwnerSectionTopProps {
  qrCode?: any;
  errors: any;
}

const ProofOfVaccination: React.FC<IProps> = ({ children }) => {
  return (
    <div className="proof-of-vaccination-card">
      <div className="proof-of-vaccination-card-content">
        <div className="proof-of-vaccination-card-content-section">{children}</div>
      </div>
    </div>
  );
};

const OwnerSectionTop: React.FC<OwnerSectionTopProps> = ({ qrCode, errors }) => {
  const { t } = useTranslation();

  const generateQr: any = () => {
    if (!qrCode) {
      return "";
    }
    return i18n.dir() === "rtl"
      ? `${process.env.REACT_APP_QR_LINK}/${qrCode}`
      : `${process.env.REACT_APP_QR_LINK_EN}/${qrCode}`;
  };

  return (
    <div className="section-top">
      <h4 className="title">{t("Proof Of Vaccination")}</h4>
      <span className="subtitle">({t("Iranian Residents")})</span>
      <div className="qr-code-wrapper">
        <div className="qr-code">
          <div className="qr-code__image">
            <div className="qr-code__image--1" />
            <div className="qr-code__image--2" />
            <div className="qr-code__image--3" />
            <div className="qr-code__image--4" />
            {errors.length > 0 && (
              <div className="qr-code__image--5">
                {errors?.map((error: any) => {
                  return <p className="error-box__content">{error.message}</p>;
                })}
              </div>
            )}

            {errors.length < 1 && (
              <>
                <div className=""> </div>
                {/* <img src={qrcode} alt=""/> */}
                <QRCode
                  // value={`${window.location.href}/result/7346-2837-6437?lang=${
                  // i18n.dir() === "rtl" ? "fa" : "en"
                  // }`}
                  renderAs="svg"
                  includeMargin={true}
                  value={generateQr()}
                  size={150}
                  className="qr-code max-w-sm"
                />
              </>
            )}
          </div>
        </div>
        {/*<div className="caption">*/}
        {/*  <span className="key">{t("QR ID")}:</span>*/}
        {/*  <span className="value">{qrCode}</span>*/}
        {/*</div>*/}
      </div>
    </div>
  );
};

const OwnerSectionMiddle: React.FC<IProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="section-middle justify-start px-32 ">
      <button type="button" className="btn-refresh">
        <div className="flex-shrink-0 w-6 h-6">
          <Refresh className="" />
        </div>
        <span />
        <span className="whitespace-nowrap">{t("Refresh QR")}</span>
      </button>
    </div>
  );
};

const OwnerSectionBottom: React.FC<OwnerSectionBottomProps> = ({ issueDate }) => {
  const { t } = useTranslation();

  const [collapsed, setCollapsed] = useState(false);
  // const [passportInfo] = useLocalStorage<IPassportInfo>("passport-info", {
  //   passportNumber: "",
  //   birthDate: "",
  //   nationalId: "",
  //   issuedDate: "",
  // });

  const passportInfo = getToken();
  const [submitted] = useLocalStorage<IPassportInfo>("passport-info", {
    passportNumber: "",
    firstName: "",
    lastName: "",
  });

  // let issuedDate = passportInfo.issuedDate;
  // if (!issuedDate) {
  //   issuedDate = "-";
  // } else {
  //   issuedDate = moment
  //     .from(issuedDate, "fa", "YYYYMMDD")
  //     .locale("fa")
  //     .format("YYYY/MM/DD");
  // }

  // let issuedDateGregorian = passportInfo.issuedDate;
  // if (!issuedDateGregorian) {
  //   issuedDateGregorian = "-";
  // } else {
  //   issuedDateGregorian = moment
  //     .from(issuedDateGregorian, "fa", "YYYYMMDD")
  //     .locale("en")
  //     .format("YYYY/MM/DD");
  // }

  let birthDate = passportInfo.birthDate;
  if (!birthDate) {
    birthDate = "-";
  } else {
    birthDate = moment.from(birthDate, "fa", "YYYYMMDD").locale("fa").format("YYYY/MM/DD");
  }

  // let birthDateGregorian = passportInfo.birthDate;
  // if (!birthDateGregorian) {
  //   birthDateGregorian = "-";
  // } else {
  //   birthDateGregorian = moment(birthDateGregorian).locale("en").format("YYYY/MM/DD");
  // }

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const tabs = [
    {
      key: "lang-en",
      title: "EN",
      tabRef: useRef(),
    },
    {
      key: "lang-fa",
      title: "FA",
      tabRef: useRef(),
    },
  ];

  return (
    <div className="section-bottom pb-8">
      {/*<div className="flex justify-center items-center mt-4">*/}
      {/*  <div className="w-14 h-7 flex items-center bg-gray-300 rounded-full mx-3 px-1 bg-blue-700">*/}
      {/*    <div*/}
      {/*      className="bg-white w-5 h-5 rounded-full shadow-md transform translate-x-7 pb-8"*/}
      {/*      onClick={() => {*/}
      {/*        i18n.changeLanguage(i18n.dir() === "rtl" ? "en" : "fa", () => {*/}
      {/*          // window.location.reload();*/}
      {/*        });*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <SwitchTabs*/}
      {/*        active={i18n.dir() === "rtl" ? "lang-fa" : "lang-en"}*/}
      {/*        tabs={tabs}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</div>*/}

      <button type="button" onClick={toggleCollapsed} className="btn-see-more cursor-pointer">
        <img
          src={seeMoreIcon}
          alt={collapsed ? t("See More") : t("Close")}
          className={`transition-transform ${collapsed ? "rotate-0" : "rotate-180"}`}
        />
        <span>{collapsed ? t("See More") : t("Close")}</span>
      </button>

      <div
        className={`overflow-hidden u-d-flex transition-flex w-full ${
          collapsed ? "flex-0" : "flex-1"
        }`}
      >
        <div className="p-4 u-d-flex flex-column w-full">
          <ul className="text-left w-full px-20">
            {i18n.dir() === "ltr" && (
              <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
                <span className="w-full text-lg text-gray-500">{t("Passport Number")}:</span>
                <span className="w-2/3 whitespace-nowrap u-font-1-2">
                  {submitted.passportNumber || "-"}
                </span>
              </li>
            )}
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">{t("National Id")}:</span>
              <span className="w-2/3 whitespace-nowrap u-font-1-2">
                {passportInfo.nationalId || "-"}
              </span>
            </li>
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500 whitespace-nowrap u-font-1-2">
                {t("Full Name")}:
              </span>
              <div className="w-full whitespace-nowrap relative overflow-hidden ltr">
                <span className="continuous-scroll-text1 px-2 u-font-1-2">
                  {i18n.dir() === "ltr" ? submitted.firstName : passportInfo.firstName || "-"}{" "}
                  {i18n.dir() === "ltr" ? submitted.lastName : passportInfo.lastName || ""}
                  {/*{capitalizeFirstLetter(passportInfo.englishName || "-")}*/}
                </span>
                <span className="continuous-scroll-text2 px-2 u-font-1-2 ">
                  {i18n.dir() === "ltr" ? submitted.firstName : passportInfo.firstName || "-"}{" "}
                  {i18n.dir() === "ltr" ? submitted.lastName : passportInfo.lastName || ""}
                  {/*{capitalizeFirstLetter(passportInfo.englishName || "-")}*/}
                </span>
              </div>
            </li>
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">{t("Date of Birth")}:</span>
              <span className="w-2/3 whitespace-nowrap u-font-1-2">
                {i18n.dir() === "rtl"
                  ? birthDate
                  : moment.from(birthDate, "fa", "YYYY/MM/DD").format("YYYY/MM/DD")}
              </span>
            </li>
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">{t("Gender")}:</span>
              <span className="w-2/3 whitespace-nowrap u-font-1-2">
                {passportInfo.gender ? t(passportInfo.gender === "1" ? "Male" : "Female") : "-"}
              </span>
            </li>
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">{t("Certificate Issued")}:</span>
              <span className="w-2/3 whitespace-nowrap u-font-1-2">
                {issueDate
                  ? i18n.dir() === "rtl"
                    ? moment(issueDate).locale("fa").format("YYYY/MM/DD")
                    : moment(issueDate).format("YYYY/MM/DD")
                  : null}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export interface IParam {
  id: string;
}

const ClientSectionTop: React.FC<IProps> = () => {
  return (
    <div className="section-top">
      <h4 className="title">Proof of Vaccination</h4>
      <span className="subtitle">(Iranian Residents)</span>

      <div className="qr-code-wrapper pb-5">
        <div className="p-4 u-d-flex flex-column w-full">
          <ul className="text-left w-full px-20">
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">Passport Number:</span>
              <span className="w-2/3 whitespace-nowrap">PF12345678</span>
            </li>
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">Name:</span>
              <span className="w-2/3 whitespace-nowrap">Negin Asadeh</span>
            </li>
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">Date of Birth:</span>
              <span className="w-2/3 whitespace-nowrap">1994-06-05</span>
            </li>
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">Gender:</span>
              <span className="w-2/3 whitespace-nowrap">Female</span>
            </li>
            <li className="u-d-flex justify-between items-center border-b border-gray-100 py-4">
              <span className="w-full text-lg text-gray-500">Certificate Issued:</span>
              <span className="w-2/3 whitespace-nowrap">2021-06-02</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const ClientSectionMiddle: React.FC<IProps> = () => {
  return (
    <div className="section-middle justify-center px-20 py-5 h-20">
      <div className="border-b border-dash border-gray-100 w-full" />
    </div>
  );
};

const ClientSectionBottom: React.FC<IProps> = () => {
  const { id } = useParams<IParam>();

  return (
    <div className="section-bottom pt-5 pb-5">
      <div className="u-d-flex flex-column">
        <span className="text-lg text-gray-500">Request ID:</span>
        <span className="text-md">{id}</span>
      </div>
    </div>
  );
};

// eslint-disable-next-line
export default {
  ProofOfVaccination,
  OwnerSectionTop,
  OwnerSectionMiddle,
  OwnerSectionBottom,
  ClientSectionTop,
  ClientSectionMiddle,
  ClientSectionBottom,
};
